import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
                 title = "Advent Tech | Calendario dell’avvento per sviluppatori",
                 description = "Un calendario dell’avvento pensato per developer e tech lovers: ogni giorno un gadget, un libro e un tool AI da scoprire!",
                 url = "https://marcoventurelli.com/advent-tech",
                 image = "https://www.marcoventurelli.com/assets/img/og-image-adventech.png",
             }) => {
    return (
        <Helmet>
            {/* Titolo e descrizione */}
            <title>{title}</title>
            <meta name="description" content={description} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="Advent Tech" />

            {/* Twitter Cards */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Favicon e manifest */}
            <link rel="icon" type="image/png" href="/favicon.png" />
            <link rel="apple-touch-icon" href="/favicon.png" />
            <link rel="manifest" href="/manifest.json" />

            {/* SEO tecnica */}
            <meta name="robots" content="index, follow" />
            <meta name="author" content="Marco Venturelli" />
            <meta charSet="utf-8" />

            <script type="application/ld+json">
                {`
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "name": "Advent Tech",
                      "url": "https://marcoventurelli.com/advent-tech",
                      "author": {
                        "@type": "Person",
                        "name": "Marco Venturelli"
                      },
                      "description": "Il calendario dell’avvento per sviluppatori, geek e tech lovers."
                    }
                `}
            </script>
        </Helmet>
    );
};

export default SEO;
